var _module_exports = "<span>This project was canceled.</span>\n";;
var path = 'views/flashes/task_canceled.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;